module.exports = __webpack_public_path__ + "static/img/hwenc-algeria.50ee965.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/hwenc-algeria.jpg
// module id = koB+
// module chunks = 0